/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import httpClient from "utils/apis/http-client";
import { showToast } from "utils/helper";
import { Button, Input } from "@repo/ui";
import styles from "./add-new-asset.module.scss";

const apiUrl = process.env.REACT_APP_API_URL;

const statusList = [
  {
    id: "Available",
    text: "Available",
  },
  {
    id: "Damaged",
    text: "Damaged",
  },
];

const assetTypes = [
  {
    id: "HHT",
    text: "HHT",
  },
  {
    id: "Cashbox",
    text: "Cashbox",
  },
  {
    id: "Printer",
    text: "Printer",
  },
  {
    id: "Pepper Spray",
    text: "Pepper Spray",
  },
];

function EditAssetCard({ asset, onAssetUpdated }: any) {
  const [cashCenters, setCashCenters] = useState<any>([]);
  const [offices, setOffices] = useState<any>([]);

  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnUpdateText, setBtnUpdateText] = useState("Save");

  const [updatedAsset, setUpdatedAsset] = useState<any>({
    assetId: asset.assetId,
    cashCenter: { id: asset.cashCenterId, text: asset.cashCenter },
    office: { id: asset.officeId, text: asset.officeName },
    description: asset.description,
    assetType: { id: asset.assetType, text: asset.assetType },
    assetNo: asset.assetNo,
    serialNo: asset.serialNo,
    model: asset.model,
    brand: asset.brand,
    status: { id: asset.status, text: asset.status },
    remarks: asset.remarks,
  });

  const [error, setError] = useState<any>({
    cashCenter: { id: "0", text: "Select Cash Center" },
    office: { id: "0", text: "Select Office" },
    description: "",
    assetType: { id: "0", text: "Select Asset Type" },
    assetNo: "",
    status: { id: "0", text: "Select Status" },
  });

  const getCashCenters = async () => {
    const cashCentersEndpoint = `${apiUrl}/lookups/cash/centers`;

    try {
      await httpClient.get(cashCentersEndpoint).then((res) => {
        if (res.status === 200) {
          const result = res.data.map((m: any) => ({
            id: m.cashCenterId,
            text: m.name,
          }));

          setCashCenters(result);
        } else {
          setCashCenters([]);
          showToast("error", "Unable to load cash centers");
        }
      });
    } catch (err) {
      setCashCenters([]);
      showToast("error", "Unable to load cash centers");
    }
  };

  const getOffices = async (cashCenterId: string) => {
    const officesEndpoint = `${apiUrl}/lookups/cash/center/offices/${cashCenterId}`;

    try {
      await httpClient.get(officesEndpoint).then((res) => {
        if (res.status === 200) {
          const result = res.data.map((m: any) => ({
            id: m.officeId,
            text: m.officeName,
          }));

          setOffices(result);
        } else {
          setOffices([]);
          showToast("error", "Unable to load cash centers");
        }
      });
    } catch (err) {
      setOffices([]);
      showToast("error", "Unable to load cash centers");
    }
  };

  useEffect(() => {
    getCashCenters();
    const cashCenterId = asset.cashCenterId;
    getOffices(cashCenterId as string);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCashCentersChanged = (event: any) => {
    const value = event.target.value;

    setUpdatedAsset({ ...updatedAsset, cashCenter: value });

    if (value.id === "0") return;
    getOffices(value.id as string);
  };

  const editAsset = async () => {
    const obj = {
      assetId: updatedAsset.assetId,
      cashCenterId: updatedAsset.cashCenter.id,
      officeId: updatedAsset.office.id,
      description: updatedAsset.description,
      assetType: updatedAsset.assetType.id,
      assetNo: updatedAsset.assetNo,
      serialNo: updatedAsset.serialNo,
      model: updatedAsset.model,
      brand: updatedAsset.brand,
      status: updatedAsset.status.id,
      remarks: updatedAsset.remarks,
    };

    setBtnDisabled(true);
    setBtnUpdateText("Updating Asset....");

    try {
      await httpClient
        .post(`${apiUrl}/resources/assets/edit`, obj)
        .then((res) => {
          if (res.status === 200) {
            setBtnDisabled(false);
            setBtnUpdateText("Save");
            setUpdatedAsset(null);
            showToast("success", "Asset updated successfully!");
            onAssetUpdated();
          } else {
            setBtnDisabled(false);
            setBtnUpdateText("Save");
            showToast("error", "Failed to update asset, try again.");
          }
        });
    } catch (err) {
      setBtnDisabled(false);
      setBtnUpdateText("Update Asset");
      showToast("error", "Failed to update asset , try again.");
    } finally {
      setBtnDisabled(false);
      setBtnUpdateText("Save");
      setBtnDisabled(false);
    }
  };

  const onBtnUpdateAssetClicked = () => {
    let errorCount = 0;

    const errorObj: any = {
      cashCenter: { id: "0", text: "Select Cash Center" },
      office: { id: "0", text: "Select Office" },
      description: "",
      assetType: "",
      assetNo: "",
      status: { id: "0", text: "Select Status" },
    };

    if (updatedAsset.cashCenter.id === "0") {
      errorCount++;
      errorObj.cashCenter = "indianred";
    }

    if (updatedAsset.office.id === "0") {
      errorCount++;
      errorObj.office = "indianred";
    }

    if (updatedAsset.description === "") {
      errorCount++;
      errorObj.description = "indianred";
    }

    if (updatedAsset.assetType.id === "0") {
      errorCount++;
      errorObj.assetType = "indianred";
    }

    if (updatedAsset.assetNo === "") {
      errorCount++;
      errorObj.assetNo = "indianred";
    }

    if (updatedAsset.status.id === "0") {
      errorCount++;
      errorObj.status = "indianred";
    }

    if (errorCount) {
      showToast("error", "Fields are required");
      setError(errorObj);
      return;
    }
    setError(errorObj);

    editAsset();
  };

  return (
    <>
      <div className="border-b mb-3 bg-accent" />

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label
            className="font-medium leading-none"
            style={{ color: error.cashCenter }}
          >
            Cash Center
          </label>
          <sup className="font-medium leading-none" style={{ color: "red" }}>
            *
          </sup>
          <DropDownList
            textField="text"
            dataItemKey="id"
            data={cashCenters}
            value={updatedAsset.cashCenter}
            onChange={onCashCentersChanged}
          />
        </div>
        <div className={styles.adduserInputs}>
          <label
            className="font-medium leading-none"
            style={{ color: error.office }}
          >
            Office
          </label>
          <sup className="font-medium leading-none" style={{ color: "red" }}>
            *
          </sup>
          <DropDownList
            textField="text"
            dataItemKey="id"
            data={offices}
            value={updatedAsset.office}
            onChange={(e) => {
              setUpdatedAsset({ ...updatedAsset, office: e.target.value });
            }}
          />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label
            className="font-medium leading-none"
            style={{ color: error.assetType }}
          >
            Asset Type
          </label>
          <sup className="font-medium leading-none" style={{ color: "red" }}>
            *
          </sup>
          <DropDownList
            textField="text"
            dataItemKey="id"
            data={assetTypes}
            value={updatedAsset.assetType}
            onChange={(e) => {
              setUpdatedAsset({ ...updatedAsset, assetType: e.target.value });
            }}
          />
        </div>

        <div className={styles.adduserInputs}>
          <label
            className="font-medium leading-none"
            style={{ color: error.description }}
          >
            Description
          </label>
          <sup className="font-medium leading-none" style={{ color: "red" }}>
            *
          </sup>
          <Input
            placeholder="Asset Description"
            value={updatedAsset.description}
            onChange={(e) => {
              setUpdatedAsset({ ...updatedAsset, description: e.target.value });
            }}
          />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label
            className="font-medium leading-none"
            style={{ color: error.assetNo }}
          >
            Asset No
          </label>
          <sup className="font-medium leading-none" style={{ color: "red" }}>
            *
          </sup>
          <Input
            placeholder="Asset No"
            value={updatedAsset.assetNo}
            style={{ borderColor: error.make }}
            onChange={(e) => {
              setUpdatedAsset({ ...updatedAsset, assetNo: e.target.value });
            }}
          />
        </div>
        <div className={styles.adduserInputs}>
          <label>Serial No</label>
          <Input
            placeholder="Asset Serial No"
            value={updatedAsset.serialNo}
            onChange={(e) => {
              setUpdatedAsset({ ...updatedAsset, serialNo: e.target.value });
            }}
          />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label>Model</label>
          <Input
            placeholder="Asset Model"
            value={asset.updatedAsset}
            onChange={(e) => {
              setUpdatedAsset({ ...updatedAsset, model: e.target.value });
            }}
          />
        </div>
        <div className={styles.adduserInputs}>
          <label>Brand</label>
          <Input
            placeholder="Asset Brand"
            value={updatedAsset.brand}
            onChange={(e) => {
              setUpdatedAsset({ ...updatedAsset, brand: e.target.value });
            }}
          />
        </div>
      </div>

      <div className={styles.adduserBox}>
        <div className={styles.adduserInputs}>
          <label
            className="font-medium leading-none"
            style={{ color: error.status }}
          >
            Status
          </label>
          <sup className="font-medium leading-none" style={{ color: "red" }}>
            *
          </sup>
          <DropDownList
            textField="text"
            dataItemKey="id"
            data={statusList}
            value={updatedAsset.status}
            onChange={(e) => {
              setUpdatedAsset({ ...updatedAsset, status: e.target.value });
            }}
          />
        </div>
        <div className={styles.adduserInputs}>
          <label>Remarks</label>
          <Input
            placeholder="Remarks"
            value={updatedAsset.remarks}
            onChange={(e) => {
              setUpdatedAsset({ ...updatedAsset, remarks: e.target.value });
            }}
          />
        </div>
      </div>

      <div className="border-b my-3 bg-accent" />
      <Button
        variant="secondary"
        className="ml-auto block w-40"
        onClick={onBtnUpdateAssetClicked}
        disabled={btnDisabled}
      >
        {btnUpdateText}
      </Button>
    </>
  );
}

export default EditAssetCard;
